export default __webpack_public_path__ + "static/media/data-center-icon.8fde13c2.svg";